import type { Box } from "../coreComponents/Box";

type DragContext = {
  node: Box | null;
  position: { x: number; y: number };
  offset: { x: number; y: number };
  store: Record<string, any>;
  // start: { x: number; y: number }; // TODO: Add start point for animation
};
export const dragContext: DragContext = {
  node: null,
  position: { x: 0, y: 0 },
  offset: { x: 0, y: 0 },
  store: {}
};

export const dragContextStore = new Proxy(dragContext.store, {
  get: (target, prop: string) => {
    return target[prop];
  },
  set: (target, prop: string, value) => {
    target[prop] = value;
    return true;
  }
});

export const getDragContext = () => Object.freeze({ ...dragContext });
